import React from 'react';
import {Row} from 'react-bootstrap';
import ld_find from 'lodash/find';

import ProductItem from './ProductItem';

class ProductGrid extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         idItemCliqued: 0,
         lastIdItem: 0,
         numPanelToOpen: 0,
         infoDetail: ""
      }

      this.handleButtonOpenDetail = this.handleButtonOpenDetail.bind(this);
   }

   /*****************************************/
   /* FUNCTION */
   /*****************************************/
   getPanelToOpen(idItem, ordre) {
      /* Ferme le panel s'il est déjà ouvert */
      if(idItem === this.state.lastIdItem) {
         this.hideAllPanels()
      } else {
         /* Sinon l'ouvre */
         const windowWidth = window.innerWidth
         const boostrapBreakpoint = {
            xs: 768,
            sm: 992,
            md: 1200
         }
         const nbrCols = () => {
            if (windowWidth <= boostrapBreakpoint.xs) {return 2}
            if (windowWidth <= boostrapBreakpoint.sm) {return 3}
            if (windowWidth <= boostrapBreakpoint.md) {return 4}
            return 6;
         }
         const numLine = Math.ceil(ordre / nbrCols())
         let numPanelToOpen = numLine * nbrCols()
         /* Vérifie si numPanelToOpen n'est pas supérieur à la collection filtrée auquel cas la fiche ne pourra s'ouvrir */
         if (numPanelToOpen > this.props.productFilteredCollection.length) {numPanelToOpen = this.props.productFilteredCollection.length}

         this.setState({numPanelToOpen: numPanelToOpen})
         this.setState({lastIdItem: idItem})
      }
   }

   hideAllPanels() {
      this.setState({
         idItemCliqued: 0,
         numPanelToOpen: 0,
         lastIdItem: 0,
         infoDetail: "",
      });
   }

   /*****************************************/
   /* HANDLE */
   /*****************************************/
   handleButtonOpenDetail(idItem, ordre) {
      this.setState({idItemCliqued: idItem})
      /* A lancer après le setState */
      this.getPanelToOpen(idItem, ordre)
   }

   /*****************************************/
   /* EVENT */
   /*****************************************/
   componentDidMount() {
      window.onresize = this.hideAllPanels.bind(this);
      window.scrollTo(0, 0);
   }

   componentWillUpdate(newProps, newStates) {
      if (this.props.filterTag !== newProps.filterTag || this.props.filterText !== newProps.filterText || this.props.sortInfo !== newProps.sortInfo) {
         this.hideAllPanels()
      }
   }
   /*****************************************/
   /* RENDER */
   /*****************************************/
   render() {
      /* Rends la collection */
      const infoDetail = ld_find(this.props.productFilteredCollection, {'id':this.state.idItemCliqued})

      const renderCollection = this.props.productFilteredCollection.map((productDetail, index) =>
      {
         return(
            <ProductItem key={productDetail.id}
               ordre={index + 1}
               sortInfo={this.props.sortInfo}
               filterTag={this.props.filterTag}
               filterText={this.props.filterText}
               infoItem={productDetail}
               infoDetail={infoDetail}
               numPanelToOpen={this.state.numPanelToOpen}
               idItemCliqued={this.state.idItemCliqued}
               onBtOpenDetail={this.handleButtonOpenDetail}
               />
         )
      });

      return (
         <Row>{renderCollection}</Row>
      );
   }
}

export default ProductGrid;



// WEBPACK FOOTER //
// ./src/ProductGrid.js